<template>
    <div>
        <div class="container mx-auto px-4">
            <img src="@/assets/logo.png" style="height:120px;"/>
        </div>

        <div class="container mx-auto mt-24 px-4">
            <div class="grid grid-cols-2 gap-8">
                <div class="xl:col-span-1 lg:col-span-1 md:col-span-2 sm:col-span-2 col-span-2"
                v-for="ev in events"
                     :key="ev.title"
                >
                    <h5 class=" pug-f-3">{{ev.type}}</h5>
                    <h1 class="text-5xl pug-f-8">
                        {{ev.title}}
                    </h1>
                    <h2 class="text-3xl pug-f-7">
                        {{ev.body}}
                    </h2>
                    <p class="pug-f-2 mt-3">{{ev.description}}</p>
                    <p class="pug-f-2 text-xs mt-3">{{ev.date}}</p>
                    <p class="mt-4"><a :href="ev.url"  target="_blank" class="pug-bgcolor-2   text-white font-bold py-2 px-4  ">
                        Maggiori dettagli
                    </a>
                    </p>
                </div>


            </div>
        </div>


        <div class="container mx-auto mt-10 px-4">
            <hr class="mb-4" />
            <h3 class="pug-f-3 text-2xl pug-color-1 mb-8">Learning by Doing</h3>
            <div class="grid grid-cols-3 gap-4">
                <div class="xl:col-span-1 lg:col-span-1 md:col-span-3 sm:col-span-3 col-span-3">
                    <div class="w-full rounded overflow-hidden shadow-lg">

                    <div class="px-6 py-4">
                        <p class="text-xs pug-f-2">VIDEO</p>
                        <div class="font-bold text-xl mb-2">Laravel Italia Live - Laravel smart APIs: filtrare dinamicamente modelli</div>
                        <p class="text-gray-700 text-base">
                            Facciamoci una chiacchiera in quarantena con Roberto Gallea che ci spiegherà come utlizzare delle API per filtrare dinamicamente i modelli.
                        </p>
                        <p class="mt-4">
                            <a href="https://www.youtube.com/watch?v=iMKObhTMKCk&t=145s"  target="_blank" class="pug-bgcolor-1   text-white font-bold py-2 px-4  ">
                                Maggiori dettagli
                            </a>
                        </p>
                    </div>
                    <div class="px-6 py-4">
                        <span class="inline-block bg-gray-200 rounded-full px-4 py-1 text-sm font-semibold text-gray-700 mr-2">#laravel</span>
                        <span class="inline-block bg-gray-200 rounded-full px-4 py-1 text-sm font-semibold text-gray-700 mr-2">#php</span>

                    </div>
                </div></div>
                <div class="xl:col-span-1 lg:col-span-1 md:col-span-3 sm:col-span-3 col-span-3">
                    <div class="w-full rounded overflow-hidden shadow-lg">

                        <div class="px-6 py-4">
                            <p class="text-xs pug-f-2">VIDEO</p>
                            <div class="font-bold text-xl mb-2">PHPDAY PUG edition</div>
                            <p class="text-gray-700 text-base">
                                Tutte le sessioni dell'evento del 14-15 maggio 2020.
                            </p>
                            <p class="mt-4">
                                <a href="https://www.youtube.com/playlist?list=PLWK9j6ps_unlwolNQrQz_XTu8Uzjk6UNm"  target="_blank" class="pug-bgcolor-1   text-white font-bold py-2 px-4  ">
                                    Maggiori dettagli
                                </a>
                            </p>
                        </div>
                        <div class="px-6 py-4">
                            <span class="inline-block bg-gray-200 rounded-full px-4 py-1 text-sm font-semibold text-gray-700 mr-2">#php</span>

                        </div>
                    </div></div>
                <div class="xl:col-span-1 lg:col-span-1 md:col-span-3 sm:col-span-3 col-span-3">
                    <div class="w-full rounded overflow-hidden shadow-lg">

                        <div class="px-6 py-4">
                            <p class="text-xs pug-f-2">VIDEO</p>
                            <div class="font-bold text-xl mb-2">Laravel Italia Live - Laravel Zero</div>
                            <p class="text-gray-700 text-base">
                                Alessandro Cappellozza ci spiegherà cosa è Laravel Zero, come utilizzarlo e come rilasciarlo in un ambiente di production ready.
                            </p>
                            <p class="mt-4">
                                <a href="https://www.youtube.com/watch?v=V-kJNL6GAN4"  target="_blank" class="pug-bgcolor-1   text-white font-bold py-2 px-4  ">
                                    Maggiori dettagli
                                </a>
                            </p>
                        </div>
                        <div class="px-6 py-4">
                            <span class="inline-block bg-gray-200 rounded-full px-4 py-1 text-sm font-semibold text-gray-700 mr-2">#php</span>

                        </div>
                    </div></div>
            </div>
        </div>

        <div class="container mx-auto mt-10 px-4">
            <hr class="mb-4" />
            <p class="text-xs pug-color-2 pug-f-1">PUG Foggia - 2020 _ foggia@grusp.org</p>
        </div>
    </div>
</template>

<script>


    export default {
        name: 'Home',
        data() {
            return {
                events: [
                  {
                    type: 'The Italian PHP Conference, Evento ONLINE',
                    title: 'PHP day is aimed to IT managers, developers and innovators',
                    body: 'Dedicated solely to PHP development and management',
                    description: '9 grandi Speakers ',
                    date: 'Martedì, 8 settembre 2020',
                    url: 'https://2020.phpday.it/'
                  },
                    {
                        type: 'PUG ROMAGNA, Evento ONLINE',
                        title: 'Organizzazione del codice in progetti medio-grandi',
                        body: 'Scrivere un programma non vuol dire solo farlo funzionare. ',
                        description: 'Un programma che funziona ma è scritto male ed è mal organizzato, avrà vita breve ',
                        date: 'Martedì, 7 luglio 2020, ore 20.30',
                        url: 'https://www.meetup.com/it-IT/PUG-Romagna-PHP-User-Group-Romagnolo/events/270743368/?fbclid=IwAR3_S-mmBl6lrFzvfDnnGs3xC0Gez4KxcwNuLRA1u5C58JrTz4yKRS0F9wQ'
                    },

                ]
            }
        },
        components: {}
    }
</script>
